import { render, staticRenderFns } from "./ProtectedApp.vue?vue&type=template&id=5859c917"
import script from "./ProtectedApp.vue?vue&type=script&lang=js"
export * from "./ProtectedApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports